import {IPriceAdapter} from "./types";

export default (price: Record<string, any> = {}): IPriceAdapter =>
  ({
    regularMaxPrice: parseFloat(price.regularMaxPrice).toFixed(2),
    regularMinPrice: parseFloat(price.regularMinPrice).toFixed(2),
    currentMaxPrice: parseFloat(price.currentMaxPrice).toFixed(2),
    currentMinPrice: parseFloat(price.currentMinPrice).toFixed(2),
    maxPercentageOff:
      price.maxPercentageOff === "0" ? 0 : parseInt(price.maxPercentageOff, 10),
    minPercentageOff:
      price.minPercentageOff === "0" ? 0 : parseInt(price.minPercentageOff, 10),
    localizedCurrencySymbol: price.localizedRegularMaxPrice[0],
    priceType: price.priceType,
  } as IPriceAdapter);
